import { render } from "./OrderTracking.vue?vue&type=template&id=13a674a6&scoped=true"
import script from "./OrderTracking.vue?vue&type=script&lang=js"
export * from "./OrderTracking.vue?vue&type=script&lang=js"

import "./OrderTracking.vue?vue&type=style&index=0&id=13a674a6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-13a674a6"

export default script